import React from 'react';
import Spinner from './Spinner';

const LoadingProgress = ({ progress }) => {
    if (!progress) {
        return <div style={{ padding: '1rem' }}><Spinner />Hämtar fakturainformation</div>;
    }

    const { loaded, total, range } = progress;
    const percent = total === 0 ? 100 : Math.round((loaded / total) * 100);

    return (
        <div style={{ padding: '1rem', maxWidth: '30rem' }}>
            <div style={{ marginBottom: '0.5rem' }}><Spinner />Hämtar fakturadetaljer: {loaded} av {total} fakturor</div>
            {range && (
                <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                    Hämtar {range.count} {range.count === 1 ? 'faktura' : 'fakturor'} för perioden {range.from} &ndash; {range.to}
                </div>
            )}
            <div
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={total}
                aria-valuenow={loaded}
                style={{ height: '1rem', backgroundColor: '#e6e6e6', borderRadius: '0.25rem', overflow: 'hidden' }}
            >
                <div style={{ width: `${percent}%`, height: '100%', backgroundColor: '#1779ba', transition: 'width 0.2s' }} />
            </div>
        </div>
    );
};

export default LoadingProgress;
